import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdateLegalDocumentRequestBody,
  IApiUpdateLegalDocumentResponseBody,
} from '../LegalDocumentsApi.types';
import { useApi } from '~/lib/api/useApi';
import { legalDocumentQueryKeyFactory } from './useLegalDocumentQuery';
import { legalDocumentsQueryKeyFactory } from './useLegalDocumentsQuery';

export type IUseUpdateLegalDocumentMutationValues = {
  appId: string;
  legalDocumentId: string;
  body: IApiUpdateLegalDocumentRequestBody;
};

export const useUpdateLegalDocumentMutation = (): UseMutationResult<
  IApiUpdateLegalDocumentResponseBody,
  unknown,
  IUseUpdateLegalDocumentMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.legalDocuments.update(
        values.appId,
        values.legalDocumentId,
        values.body,
      ),
    onSuccess: async (updatedLegalDocument) => {
      queryClient.setQueryData(
        legalDocumentQueryKeyFactory({
          appId: updatedLegalDocument.appId,
          legalDocumentId: updatedLegalDocument._id,
        })!,
        updatedLegalDocument,
      );
      await queryClient.invalidateQueries({
        queryKey: legalDocumentsQueryKeyFactory({
          appId: updatedLegalDocument.appId,
        }),
      });
    },
  });
};
